import React from "react";
import { Helmet } from "react-helmet-async";
const SchemaComponent = () => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Alignar",
    url: "https://www.alignar.com/ ",
    logo: "https://www.alignar.com/static/media/logo.5afd390b3b8234c1a89f.webp",
  };
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "How will Alignar treatment straighten my teeth?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A unique, digital treatment plan that maps out the exact movements of your teeth is created. Your Alignar clear aligners are then designed to apply the right amount of force to the right place at the right time based on your plan. We will be with you every step of the way to monitor your progress and ensure your aligners fit correctly.",
        },
      },
      {
        "@type": "Question",
        name: "How long will treatment take?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "The length of treatment depends on multiple factors, like how complex your case is and how often you wear your aligners. We will determine how long your treatment could take based on your specific needs. On average, Alignar treatment time is 3 to 9 months, though you will start seeing results in a matter of weeks.",
        },
      },
      {
        "@type": "Question",
        name: "Are there any restrictions on what I can eat while in treatment?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "None! Alignar clear aligners are removable, so there are no food restrictions. With traditional wires and brackets, there’s a long list of foods you unfortunately can’t enjoy, as they can damage or get stuck in your braces.",
        },
      },
      {
        "@type": "Question",
        name: "How much does Alignar cost and do you offer finance?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Like other types of orthodontic treatment, the price of the Alignar treatment depends on the complexity of your dental correction and your course of treatment.",
        },
      },
      {
        "@type": "Question",
        name: "Is Alignar treatment painful?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Alignar treatment moves your teeth by applying gentle, constant force, but some people do feel temporary discomfort for the first few days of wearing a new set of aligners.",
        },
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
  );
};

export default SchemaComponent;
